import { useInfiniteQuery } from '@tanstack/react-query'

import { AnalyticsTagType, BrandListingItemViewModelKibaPaginationViewModel } from '@/types/api'

import fetchRequest from '@/app/_utils/fetch-request'

import { PAGE_SIZE_OF_BRANDS } from '../constants'
import { LayoutReactQueryKeys } from '../types'

export const useGetMenuBrands = (searchQuery: string, enabled: boolean = true) => {
    const query = searchQuery.length !== 1 ? searchQuery : ''
    return useInfiniteQuery<BrandListingItemViewModelKibaPaginationViewModel>({
        queryKey: [LayoutReactQueryKeys.MenuBrands, { query }],
        queryFn: ({ pageParam = 1 }) => {
            return fetchRequest({
                serviceName: 'ntl',
                method: 'GET',
                endpoint: `/catalog/brands?analytics_tag=${AnalyticsTagType.BrandList}&page_size=${PAGE_SIZE_OF_BRANDS}&page_number=${pageParam}&query=${
                    query || ''
                }`,
            })
        },
        getNextPageParam: (lastPage) => {
            const { totalCount = 0, pageSize = PAGE_SIZE_OF_BRANDS } = lastPage || {}
            const currentPage = lastPage.pageNumber || 1
            const pageCount = Math.ceil(totalCount / pageSize)
            return currentPage >= pageCount ? undefined : currentPage + 1
        },
        initialPageParam: 1,
        enabled,
    })
}
